import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const COLORS = { Present: "#16a34a", Absent: "#dc2626" };

function AttendanceChart({ overall }) {
    const data = [
        { name: "Present", value: overall.attended },
        { name: "Absent", value: overall.absent },
    ];
    const hasData = overall.totalStudents > 0;

    return (
        <div>
            <div style={{ width: "100%", height: 220 }}>
                {hasData ? (
                    <ResponsiveContainer>
                        <PieChart>
                            <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label isAnimationActive={false}>
                                {data.map((d) => (
                                    <Cell key={d.name} fill={COLORS[d.name]} />
                                ))}
                            </Pie>
                            <Tooltip shared={false} />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                ) : (
                    <div className="d-flex align-items-center justify-content-center h-100 text-muted" style={{ fontSize: 13 }}>
                        No attendance data
                    </div>
                )}
            </div>
            <div className="d-flex justify-content-center text-muted mt-1" style={{ fontSize: 12.5, gap: 12 }}>
                <span>Attendance: <strong className="text-dark">{overall.attendancePercent}%</strong></span>
            </div>
        </div>
    );
}

export default AttendanceChart;
